<!-- 立即报名 -->
<template>
  <div class="button">
    <div @click.stop="signUp(item)">
      <img src="@/assets/hideBox/baoming.png" alt />
      <span>立即报名</span>
    </div>
  </div>
</template>

<script>
import {checkDataStatusMessage} from "@/utils/checkDataStatus"

export default {
  name: "signName",
  inject:['cardListCom'],
  props:{
    item:Object
  },
  data(){
    return {
      loading:false
    }
  },
  methods:{
    async signUp(item) {
      if(this.permissionTips({
        type:['person']
      })) return

      let no = this.item.no
      if(this.$parent.type==2){
        no = this.item.companyNo
      }
      const dataState = await checkDataStatusMessage.call(this,this.$parent.type,no)
      if(!dataState || dataState!=1){
        return
      }


      let user=this.$store.state.user;

      let state='';
      if(user.type===0){
        state=user.no==item.userNo?"操作失败，不能对自己发布的内容进行该操作":''
      }else if(user.type===1){
        state=user.companyNo==item.companyNo?"操作失败，不能对同企业发布的内容进行该操作":''
      }else if(user.type===2){
        state=user.teamNo==item.teamNo?"操作失败，不能对同团队发布的内容进行该操作":''
      }
      if(item.isApply){
        state="请勿重复报名"
      }
      if(state){
        this.$message.error(state)
        return;
      }
      this.$router.push({
        path: "/signUp",
        query: {
          no: item.no,
          categoryNo: item.categoryNo || item.category_no,
          industryNo: item.industryNo || item.industry_no,
          categoryName: item.categoryName || item.category_name,
          industryName: item.industryName || item.industry_name,
          createUser: item.createUser,
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
